import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';

const SidebarHeader = ({ styles, children }) => {
  return (
    <div className={styles.SidebarHeader}><span>{children}</span></div>
  );
};

SidebarHeader.propTypes = {
  styles: PropTypes.object.isRequired,
  children: PropTypes.node
};

export default themeable(SidebarHeader);
